import React from 'react'
import { useState, useEffect } from 'react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import NewlyCompo from '../TvShow/TvNewlyCard';

function TvNewlySlider() {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMovies = async () => {
      const url = 'https://api.themoviedb.org/3/discover/tv?api_key=2fa17ff7cae269858213010f9e657124&sort_by=release_date.desc'
      // https://api.themoviedb.org/3/movie/latest?api_key=2fa17ff7cae269858213010f9e657124

      try {
        const res = await fetch(url);
        if (!res.ok) {
          throw new Error(`HTTP error ! : ${res.status} `)
        }
        const data = await res.json();
        const filteredMovies = data.results.filter(movie => movie.poster_path); // Filter out movies without poster images
        setMovies(filteredMovies);
      } catch (error) {
        console.error('Error fetching movies', error);
        setError(error)
      }
      finally {
        setLoading(false)
      }
    }
    fetchMovies();

  }, [])

  return (
    <Swiper
      // install Swiper modules
      modules={[Navigation, Scrollbar, A11y]}
      spaceBetween={0}
      slidesPerView={4}
      navigation
      scrollbar={{ draggable: true }}
      onSwiper={(swiper) => console.log(swiper)}
      onSlideChange={() => console.log('slide change')}
      breakpoints={{
                
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1367: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      }}
    >
      {loading ? (
        <p>Loading..</p>
      ) : (
        movies.map((movie) => (
          <SwiperSlide key={movie.id}>
            <div className="rounded h-full m-1 newly-main-box relative bg-gray-800 m-2">
              <NewlyCompo movie={movie} />
            </div>
          </SwiperSlide>
        ))
      )}
    </Swiper>
  )
}

export default TvNewlySlider